import { MprcFilterLine } from "components/filter";
import { MprcButtonDropdownChecked } from "components/MprcButtonDropdownChecked";
import { KnowledgeSearchAttachDocumentType, KnowledgeSearchOption } from "generated/CoreApi_v1";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ChooseKnowledgePeriod } from "views/general/GlobalSearch/components/ChooseKnowledgePeriod";
import { GlobalSearchOrderByComponent } from "views/general/GlobalSearch/components/GlobalSearchOrderByComponent";
import { KnowledgeSearchComponent } from "views/general/GlobalSearch/components/KnowledgeSearchComponent";
import { useGlobalSearch } from "views/general/GlobalSearch/GlobalSearchProvider";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const FullDocSearch = () => {
    const { t } = useTranslation("shared");

    const {
        searchResult,
        orderBy, setOrderBy,
        dFilters: filters, setDocumentFilters: setFilters,
    } = useGlobalSearch();

    ///
    const renderFilter = useCallback(() => {
        return (
            <MprcFilterLine>
                <div>
                    <MprcButtonDropdownChecked
                        title={t("GlobalSearch.Filters.Knowledge.AttachTypeOption")}
                        selected={filters.attachDocumentType}
                        onChange={(selected) => setFilters({ attachDocumentType: selected })}
                        items={
                            [
                                { text: t("GlobalSearch.Filters.Knowledge.AttachDocumentType.Any"), value: null },
                                { text: t("GlobalSearch.Filters.Knowledge.AttachDocumentType.Pdf"), value: KnowledgeSearchAttachDocumentType.Pdf },
                                { text: t("GlobalSearch.Filters.Knowledge.AttachDocumentType.Word"), value: KnowledgeSearchAttachDocumentType.Word },
                                { text: t("GlobalSearch.Filters.Knowledge.AttachDocumentType.Excel"), value: KnowledgeSearchAttachDocumentType.Excel },
                                { text: t("GlobalSearch.Filters.Knowledge.AttachDocumentType.PowerPoint"), value: KnowledgeSearchAttachDocumentType.PowerPoint },
                                { text: t("GlobalSearch.Filters.Knowledge.AttachDocumentType.Others"), value: KnowledgeSearchAttachDocumentType.Others }
                            ]
                        }
                    />

                    <ChooseKnowledgePeriod
                        selectedOption={filters.period}
                        customStartDate={filters.periodStart}
                        customEndDate={filters.periodEnd}
                        onChange={
                            (selected, customStart, customEnd) => {
                                setFilters({ period: selected, periodStart: customStart, periodEnd: customEnd });
                            }
                        }
                    />

                </div>

                <GlobalSearchOrderByComponent
                    selectedOption={orderBy}
                    onChange={(orderBy) => setOrderBy(orderBy)}
                />

            </MprcFilterLine>
        );
    }, [filters, orderBy]);

    /////////////////////////////////////////////////////////////////////////////////////////////////

    return (
        <KnowledgeSearchComponent
            filters={filters}
            searchOption={KnowledgeSearchOption.Documents}
            initialData={searchResult?.knowledgeDocs}
            showTitle={false}
            renderFilter={renderFilter()}
            filterEmptyTextKey="shared:GlobalSearch.FullSearch.NoDocumentsFound"
            filterCountTextKey="shared:GlobalSearch.FullSearch.DocumentsFound"
        />
    );
};
